<div pRipple [ngClass]="buttonClasses" (click)="handleClick($event)">
  @if (iconPos === 'left') { @if (icon) {
  <i [class]="icon"></i>
  } @if (label) {
  <span class="label">{{ label }}</span>
  } } @else { @if (label) {
  <span class="label">{{ label }}</span>
  } @if (icon) {
  <i [class]="icon"></i>
  } }
</div>
